import React from "react";
import Lottie from "lottie-react";
import { Row, Col } from "antd";
import success from "../../assets/success.json";

const SuccessAnimation = ({ successMessage }) => {
  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Lottie
          animationData={success} // Placeholder
          loop={true}
          style={{ width: 250, height: 250 }}
          path="/success.json" // <- CRA will fetch from public folder
        />
      </div>
      <br />
      <Row justify={"center"}>
        <Col>
          <label style={{ fontSize: "large", fontWeight: 600 }}>{successMessage}</label>
        </Col>
      </Row>
    </>
  );
};

export default SuccessAnimation;
